import { every, get, has, isArray, isNull, isNumber, isString } from 'lodash';
import { ValidationResult } from '../../models';

/**
 * Checks whether data input is compatible with heat grid
 * @param dataObj Using format 2 from https://api.highcharts.com/highcharts/series.heatmap.data
 */
export const isValidHeatGridData = (dataObj: any): ValidationResult => {
  let isValid = true;
  const errors: string[] = [];

  if (dataObj == undefined) {
    isValid = false;
    errors.push('Data is not defined');
    return { isValid: isValid, errors };
  }

  if (!isArray(dataObj)) {
    isValid = false;
    errors.push(`Data should be an array, but is of type ${typeof dataObj}`);
    return { isValid, errors };
  }

  isValid = every(dataObj, dataPointObj => {
    let isDataPointNameValid = true;
    let isDataPointValueValid = true;

    if (!has(dataPointObj, 'name')) {
      isDataPointNameValid = false;
      errors.push(`'name' property should be defined`);
    } else {
      if (get(dataPointObj, 'name') && !isString(dataPointObj.name)) {
        isDataPointNameValid = false;
        errors.push(`Name should be a string, but is of type ${typeof dataPointObj.name}`);
      }
    }

    if (!has(dataPointObj, 'value')) {
      isDataPointValueValid = false;
      errors.push(`'value' property should be defined`);
    } else {
      if (get(dataPointObj, 'value') && !(isNumber(dataPointObj.value) || isNull(dataPointObj.value))) {
        isDataPointValueValid = false;
        errors.push(`Value should be a number or null, but is of type ${typeof dataPointObj.value}`);
      }
    }

    return isDataPointNameValid && isDataPointValueValid;
  });

  if (errors.length > 0) {
    console.error('Error with heat map data: ', errors);
  }

  return { isValid, errors };
};
